import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Articles() {
    const [articlesByCategory, setArticlesByCategory] = useState({});

    useEffect(() => {
        // Carica articoli dall'API
        const fetchArticles = async () => {
            try {
                const response = await fetch('https://psicopatici.com/public/api/v1/posts'); // URL dell'API
                const data = await response.json();

                // Organizza gli articoli per categoria
                const categorizedArticles = data.data.reduce((acc, article) => {
                    article.categories.forEach(category => {
                        if (!acc[category.name]) {
                            acc[category.name] = [];
                        }
                        acc[category.name].push(article);
                    });
                    return acc;
                }, {});

                setArticlesByCategory(categorizedArticles);
            } catch (error) {
                console.error('Errore durante il fetch degli articoli:', error);
            }
        };

        fetchArticles();
    }, []);

    return (
        <>
            <section className="breadcrumb_area">
                <img className="p_absolute bl_left" src="img/v.svg" alt="" />
                <img className="p_absolute bl_right" src="img/home_one/b_leaf.svg" alt="" />
                <img className="p_absolute star" src="img/home_one/banner_bg.png" alt="" />
                <img className="p_absolute wave_shap_one" src="img/blog-classic/shap_01.png" alt="" />
                <img className="p_absolute wave_shap_two" src="img/blog-classic/shap_02.png" alt="" />
                <img className="p_absolute one wow fadeInRight" src="img/home_one/b_man_two.png" alt="" />
                <img className="p_absolute two wow fadeInUp" data-wow-delay="0.2s" src="img/home_one/flower.png" alt="" />
                <div className="container">
                    <form action="#" className="banner_search_form banner_search_form_two">
                        <div className="input-group">
                            <input type="search" className="form-control" placeholder='Search ("/" to focus)' />
                            <div className="input-group-append">
                                <select className="custom-select" id="inlineFormCustomSelect">
                                    <option selected>All Categories</option>
                                    {Object.keys(articlesByCategory).map((category, index) => (
                                        <option key={index} value={category}>{category}</option>
                                    ))}
                                </select>
                            </div>
                            <button type="submit"><i className="icon_search"></i></button>
                        </div>
                    </form>
                </div>
            </section>
            <section className="page_breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-7">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item"><a href="#">Docs</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Articles</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-sm-5">
                            <a href="#" className="date"><i className="icon_clock_alt"></i>Updated on March 03, 2020</a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="doc_categories_guide_area sec_pad">
                <img className="shap" src="img/home_one/dow_bg_two.png" alt="" />
                <div className="container">
                    <div className="section_title text-center">
                        <h2 className="h_title wow fadeInUp">Check out our guide categories</h2>
                        <p className="wow fadeInUp" data-wow-delay="0.2s">Explore the articles divided by categories.</p>
                    </div>
                    <div className="row">
                        {Object.keys(articlesByCategory).map((category, index) => (
                            <div key={index} className="col-lg-4 col-sm-6">
                                <div className="categories_guide_item wow fadeInUp">
                                    <div className="doc_tag_title">
                                        <h4>{category}</h4>
                                    </div>
                                    <ul className="list-unstyled tag_list">
                                        {articlesByCategory[category].map((article) => (
                                            <li key={article.id}>
                                                <Link to={`/article/${article.slug}`}>
                                                    <i className="icon_document_alt"></i> {article.name}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    {/* <a href="#" className="doc_border_btn">More<i className="arrow_right"></i></a> */}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="text-center">
                        <a href="#" className="doc_border_btn all_doc_btn wow fadeInUp">View All Docs<i className="arrow_right"></i></a>
                    </div>
                </div>
            </section>
            <section className="doc_action_area_two">
                <div className="container">
                    <div className="doc_action_info mt_130">
                        <div className="row align-items-center">
                            <div className="col-lg-9">
                                <div className="media wow fadeInLeft">
                                    <img src="https://cdn.psicopaticiservice.com/logo/psi-v3-black-3.png" className='psico-micro-logo' alt="" />
                                    <div className="media-body">
                                        <h2 className="h_title">Sei pronto a valutare il nostro brand?</h2>
                                        <p>Manda una richiesta al nostro team specializzato oppure chiamaci.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 wow fadeInRight">
                                <Link to="/became-a-partner" className="action_btn">Diventa Partner <i className="arrow_right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Articles;
